const config = {
  appId: null,
  apiKey: null,
  firebaseUser: null,
  locale: null, // requested locale of backend responses (passed in accept-language header)
  scope: {
    orgId: null,
    spaceId: null,
    environmentId: null,
  },
  appNotification: null, // convenience function to send app notifications automatically (from ./stores/app.js)
}

export const initPlatformaone = ({appId, apiKey, firebaseUser, scope, appNotification, locale}) => {
  console.log("initPlatformaone()", {appId, apiKey, firebaseUser, scope, appNotification, locale})
  
  if (firebaseUser) {
    // the firebase auth token refreshes often, so i have to get it each time
    config.firebaseUser = firebaseUser //.getIdToken()
  } else {
    config.apiKey = apiKey
  }
  if (scope) {
    config.scope = scope
  }
  if (appId) {
    config.appId = appId
  }
  if (appNotification) {
    config.appNotification = appNotification
  }
  if (locale) {
    config.locale = locale
  }
}

export const getConfig = () => config
